/** One page of extracted markdown (e.g. from a PDF resource). */
export interface MarkdownPage {
  /** The markdown source of this page. */
  md?: string;
  /** Page label/number, used for the optional page-identification header. */
  page?: string;
}

/** Options controlling how {@link parseMarkdownArrayToString} joins pages. */
export interface ParseMarkdownOptions {
  /** Whether to include page identification headers (default false). */
  pageIdentification?: boolean;
  /** Page identification text prefix, e.g. "Page" → "*Page 3*" (default 'Page'). */
  pageText?: string;
  /** The string to use to separate each markdown object in the final string (default ''). */
  separator?: string;
}

/**
 * Joins an array of markdown pages into a single markdown string.
 * @param array An array of objects where each object represents a markdown page.
 * @param options An options object to control the output.
 * @returns Resulted markdown string (a placeholder heading when the array is empty/nullish).
 */
export function parseMarkdownArrayToString(
  array: MarkdownPage[] | null | undefined,
  { pageIdentification = false, pageText = 'Page', separator = '' }: ParseMarkdownOptions,
): string {
  const markdownString = array?.map((m, i) => {
    let pageIdent = '';
    if (pageIdentification && m.page) {
      pageIdent = i === 0 ? '' : '\n___\n'; // Horizontal line
      pageIdent += `*${pageText} ${m.page}*` + '\n\n';
    }

    return `${pageIdent}${m.md || ''}`;
  })?.join(separator) || '# <Markdown_is_empty>';

  return markdownString;
}
